import * as React from 'react'
import AdminSetting from './containers/AdminSetting'
import { Route, Switch } from 'react-router'
import AdminRoll from './containers/AdminRoll'
import { Menu, Segment } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import AdminTransaction from './containers/AdminTransaction'
import { UserManagement } from './modules/User/UserManagement'
import BannedIp from './containers/BannedIp'
import RevenuePage from './containers/RevenuePage'

export class Admin extends React.Component {
  render() {
    return (
      <Segment>
        <Menu>
          <Menu.Item>
            <Link to="/admin/setting">Setting</Link>
          </Menu.Item>
          <Menu.Item>
            <Link to="/admin/roll">Quản lý khách Roll</Link>
          </Menu.Item>
          <Menu.Item>
            <Link to="/admin/transaction">Quản lý giao dịch người dùng</Link>
          </Menu.Item>
          <Menu.Item>
            <Link to="/admin/user">Quản lý người dùng</Link>
          </Menu.Item>
          <Menu.Item>
            <Link to="/admin/ip">Quản lý IP</Link>
          </Menu.Item>
          <Menu.Item>
            <Link to="/admin/revenue">Doanh thu</Link>
          </Menu.Item>
        </Menu>
        <Switch>
          <Route path={'/admin/setting'} component={AdminSetting}/>
          <Route path={'/admin/roll'} component={AdminRoll}/>
          <Route path={'/admin/transaction'} component={AdminTransaction}/>
          <Route path={'/admin/user'} component={UserManagement}/>
          <Route path={'/admin/ip'} component={BannedIp}/>
          <Route path={'/admin/revenue'} component={RevenuePage}/>
        </Switch>
      </Segment>
    )
  }
}

export default Admin



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/Admin/Admin.tsx